// Model.js
// -----------------------
// @module Case
define("Paystand.PaystandExtensionV2.Paystand.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/Paystand/SuiteScript2/Paystand.Service.ss"
            ),
            true
        )
});
});
